import { safeFormatClientDate, safeParseISO } from 'shared/util/datetime-fns';
import { HotelWidget as SharedHotelWidget } from 'shared/widget/hotel/HotelWidget';
import { Filters } from '@/domain';

interface Props {
    filters: Pick<Filters, 'lng_sw' | 'lat_sw' | 'lng_ne' | 'lat_ne' | 'country' | 'booking_from' | 'booking_to'>;
}

export const HotelWidget = ({ filters }: Props) => (
    <SharedHotelWidget
        lngSw={filters.lng_sw ?? ''}
        latSw={filters.lat_sw ?? ''}
        lngNe={filters.lng_ne ?? ''}
        latNe={filters.lat_ne ?? ''}
        country={filters.country ?? ''}
        checkInDate={safeFormatClientDate(safeParseISO(filters.booking_from ?? ''))}
        checkOutDate={safeFormatClientDate(safeParseISO(filters.booking_to ?? ''))}
        dataUrl={process.env.NODE_ENV === 'development' ? '/reise/feriehus-hytteutleie/api/_/hotelWidget/' : undefined}
    />
);
